import { FC } from 'react';
import type { TimeInterval } from 'state/quotes/dashboard/model';

import { useAutoRefreshTimer } from './useAutoRefreshTimer';

export const AuthRefreshCountDown: FC<{ timer: TimeInterval }> = ({ timer }) => {
  const { remainingTimeInSeconds } = useAutoRefreshTimer(timer);
  return <Countdown seconds={remainingTimeInSeconds} />;
};

AuthRefreshCountDown.displayName = 'AuthRefreshCountDown';

const Countdown: FC<{ seconds: number }> = ({ seconds }) => {
  if (seconds > 0) {
    return (
      <div className="fw-semibold d-flex align-items-center">
        <span>{`${seconds}s`}</span>
        <i className="icon icon-md ms-2 mb-1">timelapse</i>
      </div>
    );
  }
  return null;
};

Countdown.displayName = 'Countdown';
